import React, { useState, useContext } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { UserContext } from "context/UserContext";

export function CrudDropdownEditDelete({
  onDelete,
  deletePermissions,
  editPermissions,
  onDeactivate,
  isActive
}) {
  const history = useHistory();
  const { pathname, state } = useLocation();
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [showDeactivateAlert, setShowDeactivateAlert] = useState(false);
  const { userHasAnyPermissions } = useContext(UserContext)

  return (
    <>
      {showDeleteAlert && (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => {
            onDelete();
          }}
          onCancel={() => setShowDeleteAlert(false)}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel>
          Are your sure you want to delete this item?
        </SweetAlert>
      )}
      {showDeactivateAlert && (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={isActive ? "Deactivate?" : "Activate?"}
          onConfirm={() => {
            onDeactivate();
            setShowDeactivateAlert(false);
          }}
          onCancel={() => setShowDeactivateAlert(false)}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText={isActive ? "Yes, deactivate" : "Yes, activate"}
          cancelBtnText="Cancel"
          showCancel>
          {isActive
            ? "This will also deactivate all associated buildings and elevators."
            : "This will also activate all associated buildings and elevators."}
        </SweetAlert>
      )}
      {(editPermissions == null || deletePermissions == null || userHasAnyPermissions([...editPermissions, ...deletePermissions])) &&
        <UncontrolledDropdown>
          <DropdownToggle className="btn-round btn-icon" color="default" outline>
            <i className="now-ui-icons loader_gear" />
          </DropdownToggle>
          <DropdownMenu end> 

            {(editPermissions == null || userHasAnyPermissions(editPermissions)) &&
              <DropdownItem onClick={() => history.push(`${pathname}/edit`, state)}>
                Edit
              </DropdownItem>
            }
            {onDeactivate && (editPermissions == null || userHasAnyPermissions(editPermissions)) &&
              <DropdownItem
                onClick={() => setShowDeactivateAlert(true)}>
                {isActive ? "Deactivate" : "Activate"}
              </DropdownItem>
            }
            {(deletePermissions == null || userHasAnyPermissions(deletePermissions)) &&
              <DropdownItem
                className="text-danger"
                onClick={(e) => {
                  setShowDeleteAlert(true);
                }}>
                Delete
              </DropdownItem>
            }
          </DropdownMenu>
        </UncontrolledDropdown>
      }
    </>
  );
}
